import React, { useState, useContext } from "react";
import "./CartItems.css";
import { Link } from 'react-router-dom'
import { ShopContext } from "../../Context/ShopContext";
import ConfirmModal from "../../Pages/ConfirmModal.jsx";
import { ReactComponent as Trash } from '../Assets/trash-icon.svg';
import clinicaConfig from "../../clinicaConfig.js";
import { IoMdClose } from "react-icons/io";

const CartItems = () => {
  const { addToCart, removeFromCart, products, cartItems, clearCart, getTotalCartItems, getTotalCartAmount } = useContext(ShopContext);

  const [modalOpen, setModalOpen] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const [modalClearOpen, setModalClearOpen] = useState(false);

  const cartItemList = products
    .filter((e) => {
      const itemKey = e.id || e._id;
      return cartItems[itemKey] > 0;
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  const handleRemoveClick = (item) => {
    const itemKey = item.id || item._id;
    if (cartItems[itemKey] === 1) {
      setItemToRemove(item);
      setModalOpen(true);
    } else {
      removeFromCart(itemKey);
    }
  };

  const confirmRemoval = () => {
    const itemKey = itemToRemove.id || itemToRemove._id;
    removeFromCart(itemKey);
    setModalOpen(false);
    setItemToRemove(null);
  };

  const cancelRemoval = () => {
    setModalOpen(false);
    setItemToRemove(null);
  };

  const handleClearCartClick = () => {
    setModalClearOpen(true);
  };

  const confirmClearCart = () => {
    clearCart();
    setModalClearOpen(false);
  };

  const cancelClearCart = () => {
    setModalClearOpen(false);
  };

  const handleAgendarExames = () => {
    if (cartItemList.length === 0) return;

    const total = getTotalCartAmount();
    const examesTexto = cartItemList
      .map((item) => {
        const itemKey = item.id || item._id;
        const preco = item.old_price && parseFloat(item.old_price) > 0
          ? ` R$${parseFloat(item.old_price).toFixed(2).replace('.', ',')}`
          : '';
        return `- ${item.name} (x${cartItems[itemKey]})${preco}`;
      })
      .join('\n');

    const textoTotal = total > 0 ? `\n\n*Valor Total Estimado: R$ ${total.toFixed(2).replace('.', ',')}*` : '';
    const mensagem = `Olá, desejo agendar os seguintes exames:\n${examesTexto}${textoTotal}`;
    const mensagemCodificada = encodeURIComponent(mensagem);
    const numeroWhatsApp = clinicaConfig.whatsapp;

    const url = `https://wa.me/${numeroWhatsApp}?text=${mensagemCodificada}`;
    window.open(url, "_blank");
  };

  return (
    <div className="cartitems-section">
      <div className="cartitems-container">
        <div className="cartitems-header-top">
          <h2>Meu Carrinho</h2>
          <div className="close-btn">
            <Link to='/Lista-de-exames'>
              <IoMdClose className="close-icon-svg" />
            </Link>
          </div>
        </div>

        <p className="cart-total-count">Você tem <strong>{getTotalCartItems()}</strong> item(s) no carrinho</p>

        <div className="cart-grid-header">
          <span>Exame</span>
          <span className="center-text">Preço Unitário</span>
          <span className="center-text">Quantidade</span>
        </div>

        <div className="cartitems-list">
          {cartItemList.length > 0 ? (
            cartItemList.map((e) => {
              const itemKey = e.id || e._id;
              return (
              <div key={itemKey} className="cart-item-row">
                <div className="cart-item-info">
                  <h4>{e.name}</h4>
                  <span className="mobile-price">
                    {e.old_price && parseFloat(e.old_price) > 0 ? `R$ ${parseFloat(e.old_price).toFixed(2).replace('.', ',')}` : 'Sob consulta'}
                  </span>
                </div>

                <div className="cart-item-price center-text">
                  {e.old_price && parseFloat(e.old_price) > 0 ? `R$ ${parseFloat(e.old_price).toFixed(2).replace('.', ',')}` : '-'}
                </div>

                <div className="cart-item-actions center-content">
                  <div className="qty-selector-cart">
                    <button onClick={() => handleRemoveClick(e)}>-</button>
                    <span>{cartItems[itemKey]}</span>
                    <button onClick={() => addToCart(itemKey)}>+</button>
                  </div>
                </div>
              </div>
              );
            })
          ) : (
            <div className="cartitems-empty">
              <p>Seu carrinho está vazio.</p>
              <Link to="/Lista-de-exames" className="btn-back-shop">Ver exames</Link>
            </div>
          )}
        </div>

        <div className="cartitems-footer">
          <div className="cart-actions-box">

            {getTotalCartItems() > 0 && (
              <div className="cart-total-summary">
                <span>Total Estimado:</span>
                <span className="total-price">
                  R$ {getTotalCartAmount().toFixed(2).replace('.', ',')}
                </span>
              </div>
            )}

            {getTotalCartItems() > 0 ? (
              <>
                <button onClick={handleAgendarExames} className="btn-agendar">
                  Agendar exames
                </button>
                <button onClick={handleClearCartClick} className="btn-clear">
                  Limpar Carrinho <Trash className="icon-trash" />
                </button>
              </>
            ) : (
              <button className="btn-agendar disabled" disabled>Agendar exames</button>
            )}
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={modalOpen}
        onConfirm={confirmRemoval}
        onCancel={cancelRemoval}
        message={
          <p>
            Tem certeza de que deseja remover o item <strong>{itemToRemove?.name}</strong> do carrinho?
          </p>
        }
      />

      <ConfirmModal
        isOpen={modalClearOpen}
        onConfirm={confirmClearCart}
        onCancel={cancelClearCart}
        message={
          <p>
            Tem certeza de que deseja <strong>limpar todo o carrinho</strong>?
          </p>
        }
      />
    </div>
  );
};

export default CartItems;